/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  OwnerFile,
  OwnerFileInput,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Owner File
 */
export const createOwnerFile = (
    ownerFileInput: MaybeRefOrGetter<OwnerFileInput>,
 signal?: AbortSignal
) => {
      ownerFileInput = toValue(ownerFileInput);

      return axiosClient<OwnerFile>(
      {url: `/owner_files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ownerFileInput, signal
    },
      );
    }




export const getCreateOwnerFileMutationKey = () => ['createOwnerFile'] as const;

export const getCreateOwnerFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,CreateOwnerFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,CreateOwnerFileMutationVariables, TContext> => {

const mutationKey = getCreateOwnerFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerFile>>, CreateOwnerFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOwnerFile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerFileMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerFile>>>
    export type CreateOwnerFileMutationBody = OwnerFileInput
    export type CreateOwnerFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateOwnerFileMutationVariables = {data: OwnerFileInput}

    /**
 * @summary Create Owner File
 */
export const useCreateOwnerFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,CreateOwnerFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOwnerFile>>,
        TError,
        CreateOwnerFileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOwnerFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Owner File
 */
export const deleteOwnerFile = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/owner_files/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteOwnerFileMutationKey = () => ['deleteOwnerFile'] as const;

export const getDeleteOwnerFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,DeleteOwnerFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,DeleteOwnerFileMutationVariables, TContext> => {

const mutationKey = getDeleteOwnerFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOwnerFile>>, DeleteOwnerFileMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteOwnerFile(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOwnerFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOwnerFile>>>

    export type DeleteOwnerFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteOwnerFileMutationVariables = {id: string}

    /**
 * @summary Delete Owner File
 */
export const useDeleteOwnerFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,DeleteOwnerFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteOwnerFile>>,
        TError,
        DeleteOwnerFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOwnerFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Owner File
 */
export const showOwnerFile = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<OwnerFile>(
      {url: `/owner_files/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowOwnerFileQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'owner_files',id
    ] as const;
    }


export const getShowOwnerFileQueryOptions = <TData = Awaited<ReturnType<typeof showOwnerFile>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowOwnerFileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showOwnerFile>>> = ({ signal }) => showOwnerFile(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData>
}

export type ShowOwnerFileQueryResult = NonNullable<Awaited<ReturnType<typeof showOwnerFile>>>
export type ShowOwnerFileQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Owner File
 */

export function useShowOwnerFile<TData = Awaited<ReturnType<typeof showOwnerFile>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowOwnerFileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






